// extracted by mini-css-extract-plugin
export default {"notification":"Notifications_notification__pzomO","notification__container":"Notifications_notification__container__iN1XK"};